import { useCallback, useMemo, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import Icon from '../Icon';
import { HiOutlineCog } from 'react-icons/hi';
import RequireRole from '@/components/auth/RequireRole';
import { useCloseOnOutsideClick } from '@/hooks/useCloseOnOutsideClick';

type SettingsItem = {
  to: string;
  label: string;
  show: boolean;
  withTopBorder?: boolean;
};

const SettingsDropdown = () => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  const close = useCallback(() => setIsOpen(false), []);
  useCloseOnOutsideClick(dropdownRef, close);

  const toggle = useCallback(() => setIsOpen(v => !v), []);

  const items = useMemo<SettingsItem[]>(
    () => [
      { to: '/admin', label: 'Admin Workspace', show: true },
      { to: '/super-admin', label: 'Super Admin Workspace', show: true },
    ],
    []
  );

  return (
    <RequireRole allowedRoles={['ADMIN', 'SUPER_USER']}>
      <div className="relative" ref={dropdownRef}>
        <button
          onClick={toggle}
          className="p-2 text-gray-500 hover:text-gray-700 hover:bg-gray-100 rounded-full focus:outline-none transition-colors flex items-center justify-center"
          aria-label="Settings"
          type="button"
        >
          <Icon icon={HiOutlineCog} className="w-5 h-5" />
        </button>

        {isOpen && (
          <div className="absolute right-0 mt-2 w-48 bg-white border border-gray-200 rounded-md shadow-lg z-50 py-1">
            <RequireRole allowedRoles={['ADMIN', 'SUPER_USER']}>
              <Link
                to={items[0].to}
                className="block px-4 py-2 text-sm font-semibold text-blue-600 hover:bg-gray-50 transition-colors"
                onClick={close}
              >
                {items[0].label}
              </Link>
            </RequireRole>

            <RequireRole allowedRoles={['SUPER_USER']}>
              <Link
                to={items[1].to}
                className="block px-4 py-2 text-sm font-semibold text-blue-600 hover:bg-gray-50 transition-colors"
                onClick={close}
              >
                {items[1].label}
              </Link>
            </RequireRole>
          </div>
        )}
      </div>
    </RequireRole>
  );
};

export default SettingsDropdown;
